export const authConfig = {
  googleAuthEnabled: false,
};
